import { Component, ElementRef, NgZone, OnChanges, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Subscription } from "rxjs";
import {
  AssigneeService,
  Population,
  PopulationAssigneesInner,
  PostAssignee,
  PopulationService,
  ClientService,
  ClientAuthListOutput,
  TaxReturnType,
  TaxReturnSubType,
  TaxReturnWithPreparerAndReviewer,
  TaxReturnTypeService,
} from "../../../../swaggerServices";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { makeName } from "../../../shared/util/makeName";
import { PopulationRouteResolver } from "./population-route-resolver.service";
import { ConfigStateService } from "../../config/config-state.service";
import { KeywordPipe } from "../../../shared/pipes/keyword.pipe";
import { AssigneeWithTaxReturns } from "../../../shared/types/assignee";
import { ActivatedRoute } from "@angular/router";
import { INote } from "../../../shared/components/notes/notes.component";
import { Tenant } from "../../../shared/types/tenant.enum";
import { TenantConfigService } from "../../../shared/services/tenant-config.service";
import { Processes } from "../../../shared/types/processState";
import { ProcessStatePollingService } from "../../../shared/services/process-state-polling.service";
import { TaxReturnTypeSubTypeService } from "../../../shared/util/tax-return-type-subtype.service";
import { DropdownListOption } from "../../../shared/components/search-dropdown/search-dropdown.component";
import { switchMap } from "rxjs/operators";
import { getQuestionnaireTypes } from "../../../shared/util/questionnaire-type.util";
import { cloneDeep } from "lodash-es";
import { forkJoin, of } from "rxjs";
import { defaultConfig } from "../../../config/default.config"
import { TranslocoService} from "@jsverse/transloco";
import { UserInfoService } from "../../user-info.service";

declare const $: any;
const numberPattern = /^\d+$/;

const filePattern = /\.(csv|xlsx)$/i;

export interface IPopulation extends Population {
  notes?: INote[];
}

@Component({
    selector: 'app-population-taxpayers',
    templateUrl: './population-taxpayers.component.html',
    styleUrls: ['./population-taxpayers.component.scss'],
    standalone: false
})
export class PopulationTaxpayersComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];

  _population?: Population;
  errorMessage?: string;

  searchText = '';
  filteredAssignees: AssigneeWithTaxReturns[] = [];

  @ViewChild('addTaxpayerModal') addTaxpayerModalEl: ElementRef;
  @ViewChild('addTaxpayerSuccessModal') addTaxpayerSuccessModalEl: ElementRef;
  @ViewChild('taxpayersUpload') taxpayersUpload: ElementRef;
  @ViewChild('taxpayersAuthListPreUpload') taxpayersAuthListPreUpload: ElementRef;
  @ViewChild("taxReturnTypeDropdown") taxReturnTypeDropdown: ElementRef;
  @ViewChild("taxReturnSubTypeDropdown") taxReturnSubTypeDropdown: ElementRef;
  taxReturnTypeDropdownObj: any;
  taxReturnSubTypeDropdownObj: any;
  addingTaxpayer: boolean;
  newTaxpayerName?: string;
  taxIdVariable: string;
  addTaxpayerForm: UntypedFormGroup;
  firstName: UntypedFormControl;
  lastName: UntypedFormControl;
  atlasId: UntypedFormControl;
  gtsId: UntypedFormControl;
  taxId: UntypedFormControl;
  taxReturnType: UntypedFormControl;
  taxReturnSubtype: UntypedFormControl;
  qnrType: UntypedFormControl;
  bulkAddAssignee: any;
  isUploading: boolean;
  hasResults: boolean; // whether csv upload has assignee results
  partialSuccessUpload: boolean;
  isEssGenerating: boolean;
  isEssTenant = false;
  lastNotified: any = null;
  taxReturnTypeById: { [id: string]: TaxReturnType } = {};
  taxReturnSubTypeById: { [id: string]: TaxReturnSubType } = {};
  authListForUploadFile: File;
  authListUploadForm: UntypedFormGroup;
  taxReturnTypeCtrl: UntypedFormControl;
  taxReturnSubTypeCtrl: UntypedFormControl;
  taxReturnTypeOptions: DropdownListOption[];
  taxReturnSubTypeOptions: DropdownListOption[];
  taxReturnSubTypeOptionsCache: { [taxReturnTypeId: string]: DropdownListOption[] } = {};
  showTypeSubType = true;
  showSubTypeDropdown = true;
  showQnrType: boolean;
  isTaxIdRequired = false;
  qnrTypeOptions: DropdownListOption[];
  selectedTaxReturnTypeId: number;
  selectedTaxReturnSubTypeId: number;
  taxReturnTypeVals: any[];
  taxReturnSubTypeVals: any[];
  currentTaxReturnTypeList: TaxReturnType[] = [];
  currentTaxReturnSubTypelist: TaxReturnSubType[] = [];
  uiConfig: TenantConfigService;
  showTaxReturnType = false;
  taxReturnAlias: string;
  taxpayerAlias: string;
  entityPrimaryName: string;
  entitySecondaryName: string;
  entitySecondaryNamePlaceholder: string;
  atlasIdVariable: string;
  gtsIdVariable: string | undefined;
  autoGenerateEntityId = true;
  message: string;
  typeAlias: string;
  subtypeAlias: string;

  constructor(private zone: NgZone,
    private assigneeService: AssigneeService,
    private populationRouteResolver: PopulationRouteResolver,
    private clientService: ClientService,
    private activatedRoute: ActivatedRoute,
    private populationService: PopulationService,
    private taxReturnTypeService: TaxReturnTypeService,
    public config: ConfigStateService,
    private processStatePollingService: ProcessStatePollingService,
    private taxReturnTypeSubTypeService: TaxReturnTypeSubTypeService,
    private translocoService: TranslocoService,
    public userInfo: UserInfoService,
  ) {
  }

  ngOnInit() {
    this.subscriptions.push(this.config.loadConfig().subscribe((config) => {
      this.uiConfig = new TenantConfigService(config);
      this.isEssTenant = this.config.tenant === Tenant.ESS;
      this.showQnrType = this.config.tenant === Tenant.AU;
      this.taxIdVariable = this.uiConfig.config.taxId;
      this.atlasIdVariable = this.uiConfig.config.atlasId;
      this.gtsIdVariable = this.uiConfig.config.gtsId;
      this.taxReturnAlias = this.uiConfig.config.taxReturnAlias;
      this.taxpayerAlias = this.uiConfig.config.taxpayerAlias;
      this.entityPrimaryName = this.uiConfig.config.entityPrimaryName;
      this.entitySecondaryName = this.uiConfig.config.entitySecondaryName;
      this.entitySecondaryNamePlaceholder = this.uiConfig.config.entityPrimaryNamePlaceholder
      this.entitySecondaryNamePlaceholder = this.uiConfig.config.entitySecondaryNamePlaceholder
      this.translocoService.selectTranslate('tax-payer-alias').subscribe(value => this.taxpayerAlias = value);
      this.translocoService.selectTranslate('tax-return-alias').subscribe(value => this.taxReturnAlias = value);
      this.translocoService.selectTranslate('type').subscribe(value => this.typeAlias = value);
      this.translocoService.selectTranslate('subtype').subscribe(value => this.subtypeAlias = value);
      if (this.showQnrType) {
        this.qnrTypeOptions = getQuestionnaireTypes();
      }
      if (this.config.tenant === Tenant.SG) {
        this.taxId.setValidators(Validators.required);
      }
      this.pollProcessStates();
    }));

    this.subscriptions.push(this.populationRouteResolver.routePopulation().subscribe(routePopulation => {
      this.population = routePopulation.population;
      this.errorMessage = routePopulation.errorMessage;
    }));

    forkJoin([
      this.taxReturnTypeService.getTaxReturnTypes(),
      this.taxReturnTypeSubTypeService.getTaxReturnSubTypes(),
    ]).subscribe(([types, subtype]: [TaxReturnType[], TaxReturnSubType[]]) => {
      this.showTaxReturnType = (types && types.length > 1) || (subtype && subtype.length > 1);
      this.populateFilters();
    });
    this.createAddTaxPayerForm();
    this.createAuthListUploadForm();
  }

  private createAddTaxPayerForm() {
    this.firstName = new UntypedFormControl('', {
      validators: [Validators.required],
    });
    this.lastName = new UntypedFormControl('', {
      validators: this.gtsIdVariable ? [Validators.required] : null,
    });
    this.atlasId = new UntypedFormControl('', {
      validators: [Validators.required, Validators.pattern(numberPattern)],
    });
    if (this.gtsIdVariable) {
      this.gtsId = new UntypedFormControl('', {
        validators: [Validators.required, Validators.pattern(numberPattern)],
      });
    }
    this.taxId = new UntypedFormControl('');
    this.taxReturnType = new UntypedFormControl('', {
      validators: [Validators.required],
    });
    this.taxReturnSubtype = new UntypedFormControl('', {
      validators: [Validators.required],
    });
    this.qnrType = new UntypedFormControl('');
    if (this.gtsIdVariable) {
      this.addTaxpayerForm = new UntypedFormGroup({
        firstName: this.firstName,
        lastName: this.lastName,
        gtsId: this.gtsId,
        taxId: this.taxId,
        atlasId: this.atlasId,
        taxReturnType: this.taxReturnType,
        taxReturnSubtype: this.taxReturnSubtype,
        qnrType: this.qnrType,
      });
    } else {
      this.addTaxpayerForm = new UntypedFormGroup({
        firstName: this.firstName,
        lastName: this.lastName,
        atlasId: this.atlasId,
        taxReturnType: this.taxReturnType,
        taxReturnSubtype: this.taxReturnSubtype,
        qnrType: this.qnrType,
      });
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
    this.processStatePollingService.cancelPolling(Processes.EssGeneration, 'population', this.population.id);
  }

  filterTaxReturn() {
    const clonedAssignees = cloneDeep(this.population.assignees);
    this.filteredAssignees = clonedAssignees.filter((a: PopulationAssigneesInner) => {
      const searchText = !this.searchText ||
        (a.firstName.toLowerCase().includes(this.searchText.toLowerCase()) ||
          a.lastName.toLowerCase().includes(this.searchText.toLowerCase()) ||
          a.atlasId.toString().toLowerCase().includes(this.searchText.toLowerCase()));
      if (a.taxReturns && a.taxReturns.length && searchText) {
        a.taxReturns = a.taxReturns.filter((tr: TaxReturnWithPreparerAndReviewer) => {
          if (this.selectedTaxReturnTypeId && this.selectedTaxReturnSubTypeId) {
            return (tr.taxReturnTypeId === this.selectedTaxReturnTypeId && tr.taxReturnSubTypeId === this.selectedTaxReturnSubTypeId);
          } else if (this.selectedTaxReturnTypeId) {
            return (tr.taxReturnTypeId === this.selectedTaxReturnTypeId);
          } else if (this.selectedTaxReturnSubTypeId) {
            return (tr.taxReturnSubTypeId === this.selectedTaxReturnSubTypeId);
          } else {
            return true;
          }
        });
        return (a.taxReturns && a.taxReturns.length);
      }
    });
  }

  pollProcessStates(): void {
    if (this.config.featureFlags.bulkGeneratePackage) {
      this.processStatePollingService.startPolling(Processes.EssGeneration, 'population', this.population.id);
    }
  }

  get population() {
    return this._population;
  }

  set population(population: Population | undefined | null) {
    this._population = population;
    this.updateFilteredAssignees();
  }

  canUpload() {
    // Hide population level upload for SG
    return this.config.tenant !== Tenant.SG && !this.isEssTenant;
  }

  canAddTaxpayer() {
    return !this.isEssTenant;
  }

  checkCountryAccess() {
    if (this.userInfo.isSuperAdmin) return true;
    if (!this.population.countryId) return true; // BASE
    if (this.userInfo.countries.some(c => c.id == this.population.countryId)) return true;
    else return false;
  }

  resetAddTaxpayerForm() {
    this.addTaxpayerForm.reset();
  }

  essGenerate() {
    this.isEssGenerating = true;
    this.populationService.essGenerate(this.population.id).subscribe();
  }

  submitAddTaxpayerForm() {
    if (!this.addTaxpayerForm.valid) {
      for (const control of Object.values(this.addTaxpayerForm.controls)) {
        control.markAsDirty();
      }
      this.focusFirstInvalidInput();
      return;
    }

    const assigneeData: PostAssignee = {
      firstName: this.firstName.value,
      lastName: this.lastName.value,
      atlasId: this.atlasId.value,
      gtsId: this.gtsIdVariable ? this.gtsId.value : this.atlasId.value,
      taxId: this.taxId.value,
      populationId: this.population.id,
      year: this.population.year,
      status: 0,
      questionnaireTypeId: this.qnrType.value,
      taxReturnTypeId: this.taxReturnType.value,
      taxReturnSubTypeId: this.taxReturnSubtype.value
    };

    this.addingTaxpayer = true;
    this.assigneeService.addAssignee(assigneeData).subscribe(
      newAssignee => {
        this.newTaxpayerName = this.gtsIdVariable ? makeName(newAssignee) : newAssignee.firstName;
        this.addingTaxpayer = false;
        const el = $(this.addTaxpayerSuccessModalEl.nativeElement);
        el.modal('show');

        // Show the newly-added assignee's tax returns
        this.populationRouteResolver.refreshPopulation(this.population.id);
      }, () => {
        this.addingTaxpayer = false;
      });
  }

  showAddTaxpayerModal() {
    this.resetAddTaxpayerForm();
    this.initTaxReturnTypeSubType();
    const el = $(this.addTaxpayerModalEl.nativeElement);
    el.modal({
      onApprove: () => {
        this.zone.run(() => {
          this.submitAddTaxpayerForm();
        });
        return false;
      },
    }).modal("show");
  }

  focusFirstInvalidInput() {
    const invalidEls = $(this.addTaxpayerModalEl.nativeElement).find('input.ng-invalid');
    if (invalidEls) {
      invalidEls[0].focus();
    }
  }

  updateFilteredAssignees() {
    if (!this.population) {
      this.filteredAssignees = [];
    } else {
      const assignees: Array<PopulationAssigneesInner> = (this.population.assignees || []).sort((a,b) => a.atlasId - b.atlasId);
      // create an array of "search data" containing flattened out tax returns, this lets us search
      // over the N tax returns of an assignee
      const searchData = [];
      assignees.forEach(assignee => {
        if (assignee.taxReturns.length === 0) {
          searchData.push({
            assigneeId: assignee.id,
            firstName: assignee.firstName,
            lastName: assignee.lastName,
            atlasId: assignee.atlasId
          });
        } else {
          assignee.taxReturns.forEach(taxReturn => {
            searchData.push({
              assigneeId: assignee.id,
              firstName: taxReturn.firstName,
              lastName: taxReturn.lastName,
              atlasId: taxReturn.atlasId
            });
          });
        }
      });

      // now do the pipe filter
      const filteredData = new KeywordPipe().transform(
        searchData,
        ['firstName', 'lastName', 'atlasId'],
        this.searchText,
        true,
      ) || [];

      // prepare the tax return types/subtypes
      this.population.taxReturnTypes.forEach(tt => {
        this.taxReturnTypeById[tt.id] = tt;
      });
      this.population.taxReturnSubTypes.forEach(tst => {
        this.taxReturnSubTypeById[tst.id] = tst;
      });

      // finally convert the filtered data back to assignees
      const assigneeIds = new Set(filteredData.map(d => d.assigneeId));
      this.filteredAssignees = assignees.filter(assignee => {
        const taxReturnList = assignee.taxReturns.filter(t => {
          return t.taxReturnTypeId === this.selectedTaxReturnTypeId;
        });
        return assigneeIds.has(assignee.id);
      });
      this.filteredAssignees.forEach(a => {
        a.taxReturns.forEach(t => {
          t.taxReturnTypeName =  this.taxReturnTypeById[t.taxReturnTypeId] ? this.taxReturnTypeById[t.taxReturnTypeId].type : '';
          t.taxReturnSubTypeName =  this.taxReturnSubTypeById[t.taxReturnSubTypeId]  ? this.taxReturnSubTypeById[t.taxReturnSubTypeId].subType : '';
        });
      });
      this.filterTaxReturn();
    }
  }

  populateFilters() {

    this.filteredAssignees.forEach(a => a.taxReturns.forEach(t => {
      if (this.currentTaxReturnTypeList && (this.currentTaxReturnTypeList.length === 0 ||
          !this.currentTaxReturnTypeList.some((tt: TaxReturnType) => ( tt && tt.id === t.taxReturnTypeId)))) {
        this.currentTaxReturnTypeList = [...this.currentTaxReturnTypeList, this.taxReturnTypeById[t.taxReturnTypeId]];
      }
      if (this.currentTaxReturnSubTypelist && (this.currentTaxReturnSubTypelist.length === 0 ||
          !this.currentTaxReturnSubTypelist.some((tt: TaxReturnSubType) => ( tt && tt.id === t.taxReturnSubTypeId)))) {
        this.currentTaxReturnSubTypelist = [...this.currentTaxReturnSubTypelist, this.taxReturnSubTypeById[t.taxReturnSubTypeId]];
      }
    }));

    setTimeout(() => {
      this.populateTaxReturnTypesDropdown();
      this.populateTaxReturnSubTypesDropdown();
    }, 100);
  }

  populateTaxReturnTypesDropdown() {
    if (this.currentTaxReturnTypeList && this.currentTaxReturnTypeList.length) {
      this.taxReturnTypeVals = [{ value: 0, name: 'All' }];
      this.taxReturnTypeVals = [...this.taxReturnTypeVals, ...this.currentTaxReturnTypeList.map(tt => {
        return {
          value: tt.id,
          name: tt.type
          // selected:
        };
      })];
      if (this.taxReturnTypeDropdown && this.taxReturnTypeDropdown.nativeElement) {
        this.taxReturnTypeDropdownObj = $(this.taxReturnTypeDropdown.nativeElement).dropdown({
          values: this.taxReturnTypeVals,
          placeholder: "Select...",
          fullTextSearch: "exact",
          preserveHTML: false,
          onChange: (value: string) => {
            if (value) {
              this.selectedTaxReturnTypeId = +value;
              this.filterTaxReturn();
            }
          },
        });
      }
    }
  }

  populateTaxReturnSubTypesDropdown() {
    if (this.currentTaxReturnSubTypelist && this.currentTaxReturnSubTypelist.length) {
      this.taxReturnSubTypeVals = [{ value: 0, name: 'All' }];
      this.taxReturnSubTypeVals = [...this.taxReturnSubTypeVals, ...this.currentTaxReturnSubTypelist.map(tt => {
        return {
          value: tt.id,
          name: tt.subType
          // selected:
        };
      })];
      if (this.taxReturnSubTypeDropdown && this.taxReturnSubTypeDropdown.nativeElement) {
        this.taxReturnSubTypeDropdownObj = $(this.taxReturnSubTypeDropdown.nativeElement).dropdown({
          values: this.taxReturnSubTypeVals,
          placeholder: "Select...",
          fullTextSearch: "exact",
          preserveHTML: false,
          onChange: (value: string) => {
            if (value) {
              this.selectedTaxReturnSubTypeId = +value;
              this.filterTaxReturn();
            }
          },
        });
      }
    }
  }

  refresh() {
    this.populationRouteResolver.refreshPopulation(this.population.id);
  }

  resetFilter() {
    this.searchText = '';
    this.selectedTaxReturnTypeId = 0;
    this.selectedTaxReturnSubTypeId = 0;
    this.updateFilteredAssignees();
  }

  createAuthListUploadForm() {
    this.taxReturnTypeCtrl = new UntypedFormControl('', {
      validators: [Validators.required]
    });
    this.taxReturnSubTypeCtrl = new UntypedFormControl('', {
      validators: [Validators.required]
    });
    this.authListUploadForm = new UntypedFormGroup({
      taxReturnType: this.taxReturnTypeCtrl,
      taxReturnSubType: this.taxReturnSubTypeCtrl,
    });

    this.taxReturnTypeCtrl.registerOnChange((a) => {
      this.taxReturnSubTypeCtrl.setValue(null);
      if (!a) { return; }
      this.updateTaxReturnSubTypes();
    });
    this.subscriptions.push(this.taxReturnTypeSubTypeService.getTaxReturnTypes().subscribe((trt: any) => {
      this.taxReturnTypeOptions = trt;
      if (this.taxReturnTypeOptions.length === 1) {
        setTimeout(() => {
          this.taxReturnTypeCtrl.setValue(this.taxReturnTypeOptions[0]);
        }, 0);
      }
    }));

    this.taxReturnSubTypeOptions = [];
    this.resetAuthListUploadForm();
  }

  resetAuthListUploadForm() {
    this.authListUploadForm.reset();
  }

  updateTaxReturnSubTypes() {
    const taxReturnTypeId = this.taxReturnTypeCtrl.value.id;
    this.taxReturnSubTypeOptions = null;

    // check local cache first
    if (this.taxReturnSubTypeOptionsCache[taxReturnTypeId]) {
      // NOTE(ajt): timeout required so the subtype select component refreshes correctly
      setTimeout(() => {
        this.taxReturnSubTypeOptions = this.taxReturnSubTypeOptionsCache[taxReturnTypeId];
        if (this.taxReturnSubTypeOptions.length === 1) {
          if (this.taxReturnSubTypeOptions.length === 1) {
            this.showTypeSubType = false;
          }
          setTimeout(() => {
            this.taxReturnSubTypeCtrl.setValue(this.taxReturnSubTypeOptions[0]);
          }, 0);
        }
      }, 0);
      return;
    }

    this.subscriptions.push(this.taxReturnTypeSubTypeService.getTaxReturnSubTypesByType(taxReturnTypeId).subscribe((tst) => {
      this.taxReturnSubTypeOptionsCache[taxReturnTypeId] = tst;
      this.taxReturnSubTypeOptions = this.taxReturnSubTypeOptionsCache[taxReturnTypeId];
      if (this.taxReturnSubTypeOptions.length === 1) {
        if (this.taxReturnTypeOptions.length === 1) {
          this.showTypeSubType = false;
        }
        setTimeout(() => {
          this.taxReturnSubTypeCtrl.setValue(this.taxReturnSubTypeOptions[0]);
        }, 0);
      }
    }));
  }

  preStartBulkUpload(files: any) {
    this.resetAuthListUploadForm();
    const isValidType = filePattern.test(files[0].name);
    delete this.authListForUploadFile;
    delete this.bulkAddAssignee;
    delete this.hasResults;
    delete this.partialSuccessUpload;

    if (isValidType) {
      this.authListForUploadFile = files[0];
      const el = $(this.taxpayersAuthListPreUpload.nativeElement);
      if (this.showTypeSubType) {
        el.modal({
          closable: false,
          onApprove: () => {
            this.zone.run(() => {
              this.bulkUpload();
            });
            return false;
          },
        }).modal("show");
      } else {
        this.zone.run(() => {
          this.bulkUpload();
        });
      }
    } else {
      this.bulkAddAssignee = {
        error: {
          message: "Please upload a file in .csv or .xlsx format."
        }
      };
      $(this.taxpayersUpload.nativeElement).modal('show');
    }
  }

  // bulk uploads a list of taxpayers
  // validates for csv file format
  bulkUpload(autoGenerateEntityId?: boolean) {
    if (autoGenerateEntityId !== undefined) {
      $(this.taxpayersUpload.nativeElement).modal('hide');
    }
    if (!this.authListUploadForm.valid && this.showTypeSubType) {
      for (const control of Object.values(this.authListUploadForm.controls)) {
        control.markAsDirty();
      }
      return;
    }

    if (!this.authListForUploadFile) { return; }
    delete this.bulkAddAssignee;
    delete this.hasResults;
    delete this.partialSuccessUpload;

    const clientId = Number(this.activatedRoute.snapshot.params.clientId);
    const populationId = Number(this.activatedRoute.snapshot.params.populationId);
    const year = this.population.year;
    const taxReturnTypeId = this.showTypeSubType ? Number(this.taxReturnTypeCtrl.value.id) : Number(this.taxReturnTypeOptions[0].value);
    const taxReturnSubTypeId = this.showTypeSubType ? Number(this.taxReturnSubTypeCtrl.value.id) : Number(this.taxReturnSubTypeOptions[0].value);
    this.isUploading = true;
    if (this.showTypeSubType) {
      $(this.taxpayersAuthListPreUpload.nativeElement).modal('hide');
    }
    this.clientService.bulkAddAssignee(clientId, this.authListForUploadFile, year, taxReturnTypeId, taxReturnSubTypeId, "", populationId, autoGenerateEntityId).subscribe(
      (d: ClientAuthListOutput) => {

        this.bulkAddAssignee = d;
        if (this.bulkAddAssignee.existingEntities) {
          this.isUploading = false;
        }else {
          // determine result message
          if (this.bulkAddAssignee.assigneesAdded.length > 0
            || this.bulkAddAssignee.assigneesUpdated.length > 0
            || this.bulkAddAssignee.assigneesLeftAlone.length > 0
            || this.bulkAddAssignee.assigneesMovedPop.length > 0
            || this.bulkAddAssignee.assigneesWithPopulationConflict.length > 0
            || this.bulkAddAssignee.assigneesToActionManually.length > 0
            || this.bulkAddAssignee.csvAssigneesWithMissingAttr.length > 0
            || this.bulkAddAssignee.newTaxReturns.length > 0
            || this.bulkAddAssignee.updatedTaxReturns.length > 0
          ) {
            this.hasResults = true;

            if (this.bulkAddAssignee.assigneesWithPopulationConflict.length > 0
              || this.bulkAddAssignee.assigneesToActionManually.length > 0
              || this.bulkAddAssignee.csvAssigneesWithMissingAttr.length > 0
            ) {
              this.partialSuccessUpload = true;
            }
          }
        }

        let m = ""
        switch (this.bulkAddAssignee.messageCode) {
          case 1:
            this.translocoService.selectTranslate('message-for-check-authlist').subscribe(value => m = value);
            break;
          default:
            this.translocoService.selectTranslate('message-for-upload-authlist-result').subscribe(value => m = value);
            break;
        }
        // set the message
        this.message =  this.bulkAddAssignee?.error ? this.bulkAddAssignee?.error.message : m

        $(this.taxpayersUpload.nativeElement).modal({ observeChanges: true }).modal('show');
        setTimeout(() => $('.ui.accordion').accordion());

        this.populationRouteResolver.refreshPopulation(populationId);
        this.isUploading = false;

      },
      (e: Error) => {
        this.bulkAddAssignee = { error: { message: e.message } };
        $(this.taxpayersUpload.nativeElement).modal('show');
        this.isUploading = false;
      });
  }

  private initTaxReturnTypeSubType() {
    const taxReturnSubTypesApiCall = this.taxReturnTypeSubTypeService.getTaxReturnSubTypes();

    this.subscriptions.push(taxReturnSubTypesApiCall.subscribe((activeSubtypes) => {
      this.showTypeSubType = activeSubtypes.length > 1;

      // Retrieve options for type and subtype
      this.subscriptions.push(this.taxReturnTypeSubTypeService.getTaxReturnTypes()
        .subscribe(options => {
          this.taxReturnTypeOptions = options;
          if (!this.showTypeSubType && options.length) {
            this.taxReturnType.setValue(options[0].value);
          }
        }));
      this.subscriptions.push(this.taxReturnType.valueChanges
        .pipe(
          switchMap((val) => {
            if (val) {
              return this.taxReturnTypeSubTypeService.getTaxReturnSubTypesByType(+val);
            }
            // if type is not selected return empty list for subtype
            return of([]);
          }))
        .subscribe((options: any[]) => {
          this.taxReturnSubTypeOptions = options;
          if (this.taxReturnSubTypeOptions.length === 1 && this.taxReturnSubTypeOptions[0].name === "default"){
            this.showSubTypeDropdown = false;
            this.taxReturnSubtype.setValue(this.taxReturnSubTypeOptions[0].id.toString());
          }else {
            this.showSubTypeDropdown = true;
            this.taxReturnSubtype.setValue('');
          }
          if (!this.showTypeSubType && options.length) {
            this.taxReturnSubtype.setValue(options[0].value);
          }
        }));
    }));
  }
}
